export const HIGHER_ED_FEEDS = [
  {
    name: "Inside Higher Ed",
    url: "https://www.insidehighered.com/rss.xml",
    alternateUrls: [
      "https://www.insidehighered.com/news/feed",
      "https://www.insidehighered.com/rss/news.xml",
      "https://news.google.com/rss/search?q=Inside+Higher+Ed&hl=en-US&gl=US&ceid=US:en",
    ],
  },
  { name: "Higher Ed Dive", url: "https://www.highereddive.com/feeds/news/" },
  {
    name: "The Chronicle",
    url: "https://www.chronicle.com/section/News/6/rss",
    alternateUrls: [
      "https://www.chronicle.com/feed",
      "https://www.chronicle.com/rss",
      "https://www.chronicle.com/blogs/ticker/feed",
      "https://news.google.com/rss/search?q=Chronicle+of+Higher+Education&hl=en-US&gl=US&ceid=US:en",
    ],
  },
  { name: "Hechinger Report", url: "https://hechingerreport.org/feed/" },
  {
    name: "EdSurge",
    url: "https://www.edsurge.com/articles_rss",
    alternateUrls: [
      "https://www.edsurge.com/articles.rss",
      "https://www.edsurge.com/feed",
      "https://news.google.com/rss/search?q=EdSurge+higher+education&hl=en-US&gl=US&ceid=US:en",
    ],
  },
  { name: "Faculty Focus", url: "https://www.facultyfocus.com/feed/" },
  { name: "WENR", url: "https://wenr.wes.org/feed/" },
  { name: "EdTech Magazine", url: "https://edtechmagazine.com/higher/rss.xml" },
  { name: "eCampus News", url: "https://www.ecampusnews.com/feed/" },
  { name: "Campus Technology", url: "https://campustechnology.com/rss-feeds/news.aspx" },
  { name: "University Business", url: "https://universitybusiness.com/feed/" },
  { name: "Diverse Education", url: "https://www.diverseeducation.com/feed/" },
  { name: "EDUCAUSE", url: "https://er.educause.edu/rss" },
  { name: "EAB", url: "https://eab.com/feed/" },
  {
    name: "Times Higher Ed",
    url: "https://www.timeshighereducation.com/news/feed",
    alternateUrls: [
      "https://www.timeshighereducation.com/academic/feed",
      "https://www.timeshighereducation.com/campus/feed",
      "https://news.google.com/rss/search?q=Times+Higher+Education&hl=en-US&gl=US&ceid=US:en",
    ],
  },
  {
    name: "Lumina Foundation",
    url: "https://www.luminafoundation.org/feed/",
    alternateUrls: [
      "https://www.luminafoundation.org/feed/rss/",
      "https://www.luminafoundation.org/feed/atom/",
      "https://news.google.com/rss/search?q=Lumina+Foundation+higher+education&hl=en-US&gl=US&ceid=US:en",
    ],
  },
];